import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              用户心声
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              听听海角网的用户们怎么说
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {commentItems.map((item) => (
              <div
                key={item.id}
                className="rounded-2xl bg-background-100 border border-background-200/60 p-5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                    <div className="text-xs text-foreground-400">{item.date}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.content}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line text-primary-500"></i>
                  <span>{item.likes.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}